import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-item-anonymity",
  templateUrl: "./ctrl-item-anonymity.component.html",
  styleUrls: ["./ctrl-item-anonymity.component.css"],
})
export class CtrlItemAnonymityComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {}

  public onChangeAnonymity() {
    this.itemChanged.emit({ item: this.item });
  }
}
